import ofApiRequest from "@dk.onlinefundraising/vue-utils/src/helpers/OfApiRequest.js";
import { user } from "./store";
import { ref } from "vue";
import axios from "axios";

export const onboardingUrl = process.env.VUE_APP_ONBOARDING_API_URL;

const allAvailableCampaigns = ref();

export default {

    login(credentials) {
        return ofApiRequest.post({
            url: onboardingUrl + `/account/Login`,
            data: credentials,
            successMessage: ''
        }).then((response) => {
            return response ? response.data : null;
        })
    },
    getAccount(authToken) {
        return ofApiRequest.get({
            url: onboardingUrl + `/account`,
            Authorization: authToken,
            successMessage: ''
        }).then((response) => {
            return response ? response.data : null;
        })
    },
    getMerchant(merchantId, agencyId) {
        return ofApiRequest.get({
            url: onboardingUrl + `/merchant/${merchantId}?agencyId=${agencyId}`,
            Authorization: user.value.authToken
        }).then((response) => {
            return response ? response.data : null;
        })
    },
    getMerchants() {
        return ofApiRequest.get({
            url: onboardingUrl + `/merchants`,
            Authorization: user.value.authToken
        }).then((response) => {
            return response ? response.data : null;
        })
    },
    getSubscription(subscriptionGuid, merchantId) {
        return ofApiRequest.get({
            url: onboardingUrl + `/relay/subscription/${subscriptionGuid}?merchantId=${merchantId}`,
            Authorization: user.value.authToken
        }).then((response) => {
            return response ? response.data : null;
        })
    },
    getAddOns(subscriptionGuid, merchantId) {
        return ofApiRequest.get({
            url: onboardingUrl + `/relay/subscription/${subscriptionGuid}/addOns?merchantId=${merchantId}`,
            Authorization: user.value.authToken
        }).then((response) => {
            return response ? response.data : null;
        })
    },
    getAgreement(agreementGuid, merchantId) {
        return ofApiRequest.get({
            url: onboardingUrl + `/relay/agreement/${agreementGuid}?merchantId=${merchantId}`,
            Authorization: user.value.authToken
        }).then((response) => {
            return response ? response.data : null;
        })
    },
    getContact(contactGuid, merchantId) {
        return ofApiRequest.get({
            url: onboardingUrl + `/relay/contact/${contactGuid}?merchantId=${merchantId}`,
            Authorization: user.value.authToken
        }).then((response) => {
            return response ? response.data : null;
        })
    },
    getPaymentMethod(paymentMethodGuid, merchantId) {
        return ofApiRequest.get({
            url: onboardingUrl + `/relay/paymentMethod/${paymentMethodGuid}?merchantId=${merchantId}`,
            Authorization: user.value.authToken
        }).then((response) => {
            return response ? response.data : null;
        })
    },
    updateAgreement(payload) {
        return ofApiRequest.post({
            url: onboardingUrl + `/session?serviceType=AgreementUpdate`,
            data: payload,
            Authorization: user.value.authToken,
            successMessage: ''
        }).then((response) => {
            return response ? response.data : null;
        })
    },
    createAddOn(payload) {
        return ofApiRequest.post({
            url: onboardingUrl + `/session?serviceType=CreateAddOn`,
            data: payload,
            Authorization: user.value.authToken,
            successMessage: ''
        }).then((response) => {
            return response ? response.data : null;
        })
    },
    changePaymentMethod(payload) {
        return ofApiRequest.post({
            url: onboardingUrl + `/session?serviceType=ChangePaymentMethod`,
            data: payload,
            Authorization: user.value.authToken,
            successMessage: ''
        }).then((response) => {
            return response ? response.data : null;
        })
    },
    holdSubscription(payload) {
        return ofApiRequest.post({
            url: onboardingUrl + `/session?serviceType=SubscriptionHold`,
            data: payload,
            Authorization: user.value.authToken,
            successMessage: ''
        }).then((response) => {
            return response ? response.data : null;
        })
    },
    restartSubscription(payload) {
        return ofApiRequest.post({
            url: onboardingUrl + `/session?serviceType=SubscriptionRestart`,
            data: payload,
            Authorization: user.value.authToken,
            successMessage: ''
        }).then((response) => {
            return response ? response.data : null;
        })
    },
    cancelSubscription(payload) {
        return ofApiRequest.post({
            url: onboardingUrl + `/session?serviceType=SubscriptionCancel`,
            data: payload,
            Authorization: user.value.authToken,
            successMessage: ''
        }).then((response) => {
            return response ? response.data : null;
        })
    },
    createAgreement(payload) {
        return ofApiRequest.post({
            url: onboardingUrl + `/session?serviceType=${payload.serviceType}`,
            data: payload,
            Authorization: user.value.authToken,
            successMessage: ''
        }).then((response) => {
            return response ? response.data : null;
        })
    },
    getPaymentSession(sessionGuid, merchantId) {
        return ofApiRequest.get({
            url: onboardingUrl + `/relay/paymentSession/${sessionGuid}?merchantId=${merchantId}`,
            Authorization: user.value.authToken
        }).then((response) => {
            return response ? response.data : null;
        })
    },
    getOnboardingSession(sessionGuid) {
        return ofApiRequest.get({
            url: onboardingUrl + `/session/${sessionGuid}`,
            Authorization: user.value.authToken
        }).then((response) => {
            return response ? response.data : null;
        })
    },
    addMerchantLicense(token) {
        return ofApiRequest.post({
            url: onboardingUrl + `/license/AddMerchantLicense`,
            data: { token: token },
            Authorization: user.value.authToken,
            successMessage: ''
        }).then((response) => {
            return response ? response.data : response;
        })
    },
    getAllAvailableCampaigns() {

        if (allAvailableCampaigns.value) {
            return new Promise((resolve) => {
                resolve(allAvailableCampaigns.value);
            });
        }

        return ofApiRequest.get({
            url: onboardingUrl + `/agency/campaigns`,
            Authorization: user.value.authToken
        }).then((response) => {
            allAvailableCampaigns.value = response ? response.data : null;
            return allAvailableCampaigns.value;
        })

    },
    startExport(campaignGuid) {
        return ofApiRequest.post({
            url: onboardingUrl + `/export/${campaignGuid}`,
            data: {},
            Authorization: user.value.authToken,
            successMessage: ''
        }).then((response) => {
            return response ? response.data : response;
        })
    },
    getExport(exportGuid) {
        return ofApiRequest.get({
            url: onboardingUrl + `/export/exportrequest/${exportGuid}`,
            Authorization: user.value.authToken,
            successMessage: ''
        }).then((response) => {
            return response ? response.data : response;
        })
    },
    downloadExport(exportGuid) {
        return axios.get(
            onboardingUrl + `/exportdownload/${exportGuid}`,
            {
                responseType: 'blob',
                headers: {
                    Authorization: user.value.authToken
                }
            }
        ).then((response) => {
            return response ? response.data : null;
        })
    },
    getUsers() {
        return ofApiRequest.get({
            url: onboardingUrl + `/users`,
            Authorization: user.value.authToken,
            successMessage: ''
        }).then((response) => {
            return response ? response.data : response;
        })
    },
    requestPasswordReset(userGuid) {
        return ofApiRequest.post({
            url: onboardingUrl + `/account/${userGuid}/ResetPassword`,
            data: {},
            Authorization: user.value.authToken,
            successMessage: 'Email sent with reset link'
        }).then((response) => {
            return response ? response.data : response;
        })
    },
    updateUser(userData) {
        return ofApiRequest.put({
            url: onboardingUrl + `/user/${userData.userGuid}`,
            data: userData,
            Authorization: user.value.authToken,
            successMessage: 'Updated'
        }).then((response) => {
            return response ? response.data : response;
        })
    },
    archiveUser(userGuid) {
        return ofApiRequest.post({
            url: onboardingUrl + `/user/${userGuid}/Archive`,
            data: {},
            Authorization: user.value.authToken,
            successMessage: 'Archived'
        }).then((response) => {
            return response ? response.data : response;
        })
    },
    createUser(userData) {
        return ofApiRequest.post({
            url: onboardingUrl + `/user`,
            data: userData,
            Authorization: user.value.authToken,
            successMessage: 'Updated'
        }).then((response) => {
            return response ? response.data : response;
        })
    },


}